import { useQuery } from '@tanstack/react-query';

import { ICON_URL_STALE_TIME } from '../../../app/constants';
import { queryClient } from '../../../api/queryClient';
import {
  getV1OauthClientByIdOptions,
  getV1OauthClientsOptions,
  getV1OauthClientsQueryKey,
} from '../../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the Custom Applications settings page: the OAuth Clients of
 * the current Business Partner and one Client's details. See
 * `../IdentityProviders/identityProviders.queries.ts` for the pattern.
 */

/** Custom Applications (OAuth Clients) of the current Business Partner. */
export const useCustomApplications = () =>
  useQuery({
    ...getV1OauthClientsOptions(),
    staleTime: ICON_URL_STALE_TIME,
    refetchOnMount: true,
  });

/** Clears the Custom Applications list. */
export const invalidateCustomApplications = () =>
  queryClient.invalidateQueries({ queryKey: getV1OauthClientsQueryKey() });

export const useCustomApplication = (id?: string) =>
  useQuery({
    ...getV1OauthClientByIdOptions({ path: { id: id as string } }),
    enabled: !!id,
    staleTime: ICON_URL_STALE_TIME,
    refetchOnMount: true,
  });
